import './CourseCertificationContainer.css'
import SectionTitle from '../../../components/SectionTitle/SectionTitle'
import certificationImage from '../../../assets/course/certificationImage.png'

export default function CourseCertificationContainer({certificate, courseCertifications}) {
    const {title, subtitle, textInfo} = courseCertifications;
    return (
        <div className='course-certification-container'>
            <div className='course-certification-heading'>
                <SectionTitle upText={subtitle} downText={title}/>
                <p className='course-certification-heading-description'>{textInfo}</p>
            </div>
            <div className='certification-image-container'>
                <img className='certification-image' src={certificate ?? certificationImage}
                      alt='foto de certificado'/>
            </div>
        </div>
    )
}
